import(/* webpackMode: "eager" */ "/var/www/html/brasal.com.br/frontend-portal-brasal/src/app/noticias/dinamic.tsx")